module.exports = __webpack_public_path__ + "img/sand-decal-06.69af4d7b.png";